<template>
    <Layout :showNav="false">
        <app-head title="Private Gym - Sportschool Deventer - Welkom" />

<!--        <contact-modal-->
<!--            v-if="showFormModal"-->
<!--            @closed="showFormModal = false"-->
<!--            type="interest"-->
<!--        ></contact-modal>-->

<!--    </Layout>-->
    <header>
        <nav class="navbar navbar-expand-lg navbar-light bg-light" style="z-index: 2000;">
            <top-nav :open-menu="openMenu" @clicked="openMenu = !openMenu" :darkLogo="true"></top-nav>
        </nav>
        <!-- Navbar -->

        <video-header></video-header>

        <!-- Carousel wrapper -->
<!--        <div id="introCarousel" class="carousel slide carousel-fade shadow-2-strong" data-mdb-ride="carousel">-->
<!--            &lt;!&ndash; Indicators &ndash;&gt;-->
<!--            <ol class="carousel-indicators">-->
<!--                <li data-mdb-target="#introCarousel" data-mdb-slide-to="0" class="active"></li>-->
<!--                <li data-mdb-target="#introCarousel" data-mdb-slide-to="1"></li>-->
<!--                <li data-mdb-target="#introCarousel" data-mdb-slide-to="2"></li>-->
<!--                <li data-mdb-target="#introCarousel" data-mdb-slide-to="3"></li>-->
<!--            </ol>-->

<!--            &lt;!&ndash; Inner &ndash;&gt;-->
<!--                &lt;!&ndash; Single item &ndash;&gt;-->
<!--            <carousel :active="currentSlide === 0">-->
<!--                <frontpage-carousel-item></frontpage-carousel-item>-->
<!--            </carousel>-->

<!--            &lt;!&ndash; Single item &ndash;&gt;-->
<!--            <carousel :active="currentSlide === 1">-->
<!--                <frontpage-carousel-item></frontpage-carousel-item>-->
<!--            </carousel>-->

<!--            &lt;!&ndash; Single item &ndash;&gt;-->
<!--            <carousel :active="currentSlide === 2">-->
<!--                <frontpage-carousel-item :show-logo="false"></frontpage-carousel-item>-->
<!--            </carousel>-->

<!--            &lt;!&ndash; Single item &ndash;&gt;-->
<!--            <carousel :active="currentSlide === 3">-->
<!--                <frontpage-carousel-item></frontpage-carousel-item>-->
<!--            </carousel>-->
<!--        </div>-->
<!--        &lt;!&ndash; Controls &ndash;&gt;-->
<!--        <a class="carousel-control-prev" href="#introCarousel" role="button" data-mdb-slide="prev">-->
<!--            <span class="carousel-control-prev-icon" aria-hidden="true"></span>-->
<!--            <span class="sr-only">Previous</span>-->
<!--        </a>-->
<!--        <a class="carousel-control-next" href="#introCarousel" role="button" data-mdb-slide="next">-->
<!--            <span class="carousel-control-next-icon" aria-hidden="true"></span>-->
<!--            <span class="sr-only">Next</span>-->
<!--        </a>-->
        <!-- Inner -->

        <!-- Carousel wrapper -->
    </header>
    <!--Main Navigation-->

    <!--Main layout-->
    <main class="mt-5">
        <div class="container">
            <!--Section: Content-->
            <section class="m-4">
                <div class="row  justify-content-center">
<!--                    <div class="col-md-6 gx-5 mb-4">-->
<!--                        <div class="bg-image hover-overlay ripple shadow-2-strong rounded-5" data-mdb-ripple-color="light">-->
<!--                            <img src="https://mdbootstrap.com/img/new/slides/031.jpg" class="img-fluid" />-->
<!--                            <a href="#!">-->
<!--                                <div class="mask" style="background-color: rgba(251, 251, 251, 0.15);"></div>-->
<!--                            </a>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    <div class="col-sm-10 col-12 display-5 mb-6" style="font-size: 1.5em;">-->
<!--                        <div class="row">-->
<!--                            <div class="col-12 col-lg-6 mt-3"><i class="bi bi-chevron-right me-2"></i>Gebrek aan privacy?</div>-->
<!--                            <div class="col-12 col-lg-6 mt-3"><i class="bi bi-chevron-right me-2"></i>Dumbbells delen?</div>-->
<!--                            <div class="col-12 col-lg-6 mt-3"><i class="bi bi-chevron-right me-2"></i>Wachten?</div>-->
<!--                            <div class="col-12 col-lg-6 mt-3"><i class="bi bi-chevron-right me-2"></i>Zoeken naar materiaal?</div>-->
<!--                            <div class="col-12 col-lg-6 mt-3"><i class="bi bi-chevron-right me-2"></i>Onzeker in het sporten?</div>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="col-12">
                        <header-and-text-block header-placement="left">
                            <template v-slot:header>
                                Drukte in de gym?
                            </template>
                            Ben je net lekker aan het trainen, tikt iemand je aan om te vragen hoe lang je die dumbbells nog gebruikt. Je kunt over de koppen lopen. Het is warm. Het stinkt. En met regelmaat moet je de volgorde van je oefeningen omgooien want: bezet. Bij Private Gym is dat verleden tijd. Je kunt 24/7 ongestoord trainen op je eigen 15m2 vol sportmateriaal. Je eigen Power Rack, Dumbbells, Halters, Kettlebells en meer. Alles alleen voor jou. Voor jouw training. Met professionele begeleiding en hulp bij je doelen. Zelfs als alle eilanden bezet zijn, is het nog steeds lekker rustig.
                        </header-and-text-block>
                    </div>
                    <div class="col-lg-6 col-12 mb-3">
                        <div class="card bg-dark text-white image-card">
                            <video controls="controls" autoplay="autoplay" loop="loop" style="width:100%;">
                                <source src="/video/private_gym_intro_1080p.mp4" type="video/mp4">
                            </video>
                        </div>
                    </div>
                    <div class="col-lg-6 col-12 mb-2">
                        <review-box
                            link="https://www.trustpilot.com/reviews/635d0a2c252cba2c02c95565"
                            name="Koen Boswinkel"
                            date="2022-10-29"
                            title="Ontspannen en respectvol"
                            text="Alles is voorhanden om een complete training te doen, ook als je daar niet veel ervaring mee hebt. Er is voldoende mogelijkheid voor begeleiding. De grote winst en het unieke punt ten opzichte van andere sportscholen is echter de sfeer: er is geen enkele vorm van judgement, geen opgepompt gedoe. Sterker nog, leden helpen elkaar onderling met oefeningen en brengen elkaar zo verder. Ontspannen en met respect voor elkaar sporten! Dat is voor mij echt de meerwaarde van Private Gym"
                        ></review-box>
                    </div>
                    <div class="col-12">
                        <header-and-text-block header-placement="right">
                            <template v-slot:header>
                                Aan je lot overgelaten?
                            </template>
                            Je kent het wel. Je schrijft je vol goede moed in bij de sportschool. Twee maanden later ben je niet of nauwelijks meer richting de gym te krijgen. Niemand die naar je omkijkt. Het enige wat je nog ziet, is de automatische incasso. Bij ons, gaat dit anders. Ieder lid krijgt persoonlijke aandacht. Dat begint al bij de rondleiding. Gaat verder bij de techniek training. En houdt nooit op door de trainers die vaak rondlopen. Plus de check-in die we sowieso maandelijks bij je doen.
<!--                            Bij Private Gym zal dit anders gaan. Ons team staat klaar om je non-stop te begeleiden. Zodat je <em>wel</em> gaat. Wij helpen jou gezond, fit en gemotiveerd te blijven.-->
                        </header-and-text-block>
                    </div>




                    <div class="col-12 mb-3">
                        <div class="row">
                            <div class="col-sm-4 my-4">
                                <image-card
                                    img_url="/images/gym/8.jpeg"
                                    img_alt=""
                                >
                                </image-card>
                            </div>
                            <div class="col-sm-4 my-4">
                                <image-card
                                    img_url="/images/gym/9.jpeg"
                                    img_alt=""
                                >
                                </image-card>
                            </div>

                            <div class="col-sm-4 my-4">
                                <image-card
                                    img_url="/images/gym/21.jpeg"
                                    img_alt=""
                                >
                                </image-card>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <header-and-text-block header-placement="left">
                            <template v-slot:header>
                                Je voelt je bekeken?
                            </template>
                            Helaas komt het veel te vaak voor dat je geen lekker gevoel hebt in de gym. Je voelt je als vrouw bekeken. Of als man heb je het idee dat je op een apenrots zit. Bij Private Gym zul je een andere sfeer ervaren. Waar iedereen komt voor zijn gezondheid, en om te sporten. Niet om gezien te worden. Dat alles in een warme, huiselijke setting. Waar iedereen respectvol met elkaar omgaat.
                        </header-and-text-block>
                    </div>

                    <div class="col-12">
                        <header-and-text-block header-placement="right">
                            <template v-slot:header>
                                Last van asociaal gedrag?
                            </template>
                            Rommel. Hardop telefoneren. TikTok / Instagram fotoshoots. Het constant bezet houden van apparatuur. Wij hebben het ook gezien. Bij Private Gym, liever niet. Via de app kun je melding doen van asociaal gedrag. Gelukkig is dit nog niet nodig geweest. Komt het door de ontbrekende spiegelmuur? De duidelijke huisregels? Wie zal het zeggen. Maar feit is - bij Private Gym train je in rust en privacy. Met alleen maar leuke leden.
                        </header-and-text-block>
                    </div>





                    <div class="col-12 mb-3">
                        <div class="row">
                            <div class="col-sm-4 my-4">
                                <image-card
                                    img_url="/images/gym/12.jpeg"
                                    img_alt=""
                                >
                                </image-card>
                            </div>
                            <div class="col-sm-4 my-4">
                                <image-card
                                    img_url="/images/gym/14.jpeg"
                                    img_alt=""
                                >
                                </image-card>
                            </div>

                            <div class="col-sm-4 my-4">
                                <image-card
                                    img_url="/images/gym/16.jpeg"
                                    img_alt=""
                                >
                                </image-card>
                            </div>
                        </div>
                    </div>


                    <div class="col-12">
                        <header-and-text-block header-placement="left">
                            <template v-slot:header>
                                Het beste van de sportschool + het beste van een Personal training studio
                            </template>
                            We zeggen het maar eerlijk: er gaat niets boven personal training. Maar om dat nou 3x per week te doen... Dan lopen de kosten snel op. En een reguliere gym - daar moet je het zelf maar uitzoeken. Bij Private Gym lopen met regelmaat personal trainers rond die je kunnen helpen. Service van de zaak. Maar de gym is <em>ook</em> 24/7 open. <em>En</em> betaalbaar. Uiteraard betaal je meer dan bij een prijsvechter. Maar daar krijg je dan ook een bak aan service voor terug. Het is een investering in jezelf.
                        </header-and-text-block>
                    </div>
                    <div class="col-12">
                        <header-and-text-block header-placement="right">
                            <template v-slot:header>
                                Nieuwsgierig naar het concept?
                            </template>
                            Vraag een rondleiding aan en kom kijken en ervaren. De gym is in het echt nog mooier dan op de foto's. De sfeer fijner dan je hoopt en het traint nog lekkerder dan je denkt ;-) Nooit meer wachten, lopen of delen. Iedere training lekker snel klaar. Je oefeningen gedaan in de volgorde die jij wil. Met de materialen die jij het fijnste vindt. Hopelijk vind jij bij Private Gym je nieuwe fitness thuis!
                        </header-and-text-block>
                    </div>

                    <div class="col py-5 my-5 mt-2 mb-sm-4">
                        <action-buttons :colored="true" :icon="true"></action-buttons>
                    </div>

                    <div class="col-12"></div>

                    <all-reviews></all-reviews>

                    <div class="col my-5 py-5 text-center">
                        <h1 class="mb-5">
                            <strong>
                                Kom even kijken
                            </strong>
                        </h1>
                        <action-buttons :colored="true" :icon="true"></action-buttons>
                    </div>
                </div>
            </section>
        </div>
    </main>
    <!--Main layout-->

    <!--Footer-->
                <!--            <a role="button" class="btn btn-primary btn-lg m-2"-->
                <!--               href="https://www.youtube.com/channel/UC5CF7mLQZhvx8O5GODZAhdA" rel="nofollow" target="_blank">-->
                <!--                Learn Bootstrap 5-->
                <!--            </a>-->
                <!--            <a role="button" class="btn btn-primary btn-lg m-2" href="https://mdbootstrap.com/docs/standard/" target="_blank">-->
                <!--                Download MDB UI KIT-->
                <!--            </a>-->




                <!--            <a type="button" class="btn btn-success btn-lg px-4 col-md-3 col-sm-6" href="https://wa.me/+31652048431?text=Ik%20zou%20graag%20wat%20meer%20informatie%20willen%20over%20Private%20Gym" rel="_blank">-->
                <!--                <i class="bi bi-whatsapp" style="margin-right: 12px;"></i>-->
                <!--                <span style="display: inline-block;">-->
                <!--                                    WhatsApp-->
                <!--                                </span>-->
                <!--            </a>-->
                <!--            <a type="button" class="btn btn-success instagram btn-lg px-4 col-md-3 col-sm-6 mx-2" href="https://instagram.com/privategym_nl" rel="_blank">-->
                <!--                <i class="bi bi-instagram" style="margin-right: 12px;"></i>-->
                <!--                <span style="display: inline-block;">-->
                <!--                                    Instagram-->
                <!--                                </span>-->
                <!--            </a>-->
        <bottom-floating-bar></bottom-floating-bar>
</Layout>

</template>

<script>
import Layout from '../Components/Layout'
import AppHead from "../Components/AppHead";
import axios from "axios";
import vClickOutside from 'click-outside-vue3'
import ContactModal from "../Components/Contact/ContactModal";
import Carousel from "../Components/Index/Carousel";
import ActionButtons from "../Components/Index/ActionButtons";
import CarouselFotos from "../Components/Index/CarouselFotos";
import TopNav from "../Components/Nav/TopNav";
import TestimonialCard from "../Components/Index/TestimonialCard";
import WhatsappFloatingButton from "../Components/Index/WhatsappFloatingButton";
import ReviewBox from "../Components/Reviews/ReviewBox";
import FrontpageCarouselItem from "../Components/Index/FrontpageCarouselItem";
import HeaderAndTextBlock from "../Components/Layout/HeaderAndTextBlock";
import ImageCard from "../Components/Index/ImageCard";
import AllReviews from "../Components/Reviews/AllReviews";
import VideoHeader from "../Components/Index/VideoHeader";
import BottomFloatingBar from "../Components/Index/BottomFloatingBar.vue";

export default {
    components: {
        BottomFloatingBar,
        VideoHeader,
        AllReviews,
        ImageCard,
        HeaderAndTextBlock,
        FrontpageCarouselItem,
        ReviewBox,
        WhatsappFloatingButton,
        TestimonialCard,
        TopNav,
        CarouselFotos,
        ActionButtons,
        Carousel,
        ContactModal,
        AppHead,
        Layout,
    },
    props: {
        user: Object,
    },
    data() {
        return {
            showFormModal: false,
            activeSlide: 0,
            openMenu: false,
        }
    },
    computed: {
        currentSlide() {
            return this.activeSlide % 3;
        }
    },

    methods: {

    }
}
</script>

<style lang="scss">
@import '~mdb-ui-kit/css/mdb.min.css';

/* Carousel styling */
#introCarousel,
.carousel-inner,
.carousel-item,
.carousel-item.active {
    height: 100vh;
}


.carousel-item:nth-child(5) {
    background-image: url('/images/gym/7.jpeg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center top;
}

.carousel-item:nth-child(4) {
    background-image: url('/images/gym/2.jpeg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center top;
}

.carousel-item:nth-child(2) {
    background-image: url('/images/gym/15.jpeg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
}

.carousel-item:nth-child(3) {
    background-image: url('/images/gym/5.jpeg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
}

/* Height for devices larger than 576px */
@media (min-width: 992px) {
    #introCarousel {
        margin-top: -58.59px;
    }
}

.card .bg-image {
    background-position: center center;
}

.instagram{
    border-color: rgba(0,0,0,0);
    background: #f09433;
    background: -moz-linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
    background: -webkit-linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%);
    background: linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f09433', endColorstr='#bc1888',GradientType=1 );
}
</style>
